import Highcharts from "highcharts/highstock";

export const returnHighChartDate = (highchartData) => {
        return `${Highcharts.dateFormat("%e %b %Y", new Date(highchartData.x))}<br/>${`<b>${highchartData.series.name}</b>: ` + highchartData.point.y}`;

};